export default __webpack_public_path__ + "static/media/Dotimatrix-5.ttf.7506ac5d.svg";